import {
  SET_USER_MODEL_CATEGORIES
} from '../constants/index';

const initialState = {
  userOrganisationModelCategory: [],
  isLoading: false
};

const userOrganisationModelCategories = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case SET_USER_MODEL_CATEGORIES: {
      const { modelCategories } = payload;
      return {
        ...state,
        userOrganisationModelCategory: modelCategories
      };
    }

    default:
      return state;
  }
};

export default userOrganisationModelCategories;
